<template>
  <div class="side-wrapper p-3">
    <div class="row">
      <div class="col-md-12">
        <div class="section-wrapper d-flex py-3">
         <div class="root-img d-flex" v-if="compliant">
              <img
                :src="$root.serverBasePath + '/verified.png'"
                alt="Strata Connex"
                height="40px"
              />

              <p class="ml-3 mb-0">
                Verified by Strata Connex<br />
                <span>100% Compliant</span>
              </p>
          </div>
          <div class="root-img d-flex" v-else>
              <i
                style="font-size: 40px"
                class="fas fa-exclamation-circle fa-2x unverified"
              ></i>

              <p class="ml-3 mb-0">Not Verified by Strata Connex<br /></p>
          </div>
          <!-- <div class="text-right" style="width: 50%">
            <i
              v-if="isAllInsuranceVerified"
              class="fas fa-check-circle"
              style="font-size: 50px; color: rgb(0, 186, 136)"
            ></i>
            <i
              v-else
              class="fas fa-times-circle"
              style="font-size: 50px; color: rgb(237, 46, 126)"
            ></i>
          </div> -->
        </div>
      </div>
    </div>

    <div class="detail-section bg-white p-3">
      <div class="row">
        <div class="col-lg-12">
          <div
            v-for="(insurance, index) in insurances_info"
            :key="index"
            class="mb-2"
          >
            <div class="row">
              <div class="col-md-8 text-left">
                <h4
                  v-if="insurance.insurance_type == 'public-liability'"
                >
                  Public Liability
                </h4>

                <h4
                  v-if="insurance.insurance_type == 'workers-compensation'"
                >
                  Workers Compensation
                </h4>

                <h4
                  v-if="insurance.insurance_type == 'professional-indemnity'"
                >
                  Professional Indemnity
                </h4>

                <h4
                  v-if="insurance.insurance_type == 'other-insurances'"
                >
                  Other Insurance
                </h4>
              </div>
              <div class="col-md-4 text-right">
                <SvgIcons
                  v-if="insurance.insurance_status == 'verified'"
                  icon="icon-verified"
                  width="25"
                  height="25"
                  svgClass="mb-1 ml-5 pull-right"
                />
                <SvgIcons
                  v-else
                  icon="icon-error"
                  width="25"
                  height="25"
                  svgClass="mb-1 ml-5 pull-right"
                />
              </div>
            </div>
    
            <div v-if="insurance.insurance_status == 'verified'" class="insurance">
                <ul style="margin-bottom: 0;">
                    <li v-if="insurance.insurance_policy">
                        <span class="title">Policy No:</span>
                        <span class="sub-title">{{ insurance.insurance_policy }}</span>
                    </li>

                    <li v-if="insurance.insurance_start">
                        <span class="title">Start Date:</span>
                        <span class="sub-title">{{ momentDate(insurance.insurance_start) }}</span>
                    </li>

                    <li v-if="insurance.insurance_expiry">
                        <span class="title">Expiry Date:</span>
                        <span class="sub-title">{{ momentDate(insurance.insurance_expiry) }}</span>
                    </li>

                    <li v-if="insurance.period_of_cover">
                        <span class="title">Period of Cover:</span>
                        <span class="sub-title">{{ insurance.period_of_cover }}</span>
                    </li>

                    <li v-if="insurance.insurance_limit">
                        <span class="title">Limit of Liability ($):</span>
                        <span class="sub-title">{{  insurance.insurance_limit.toLocaleString() }}</span>
                    </li>

                    <li v-if="insurance.additional_benefit">
                        <span class="title">Additional Benefits ($):</span>
                        <span class="sub-title">{{  insurance.additional_benefit.toLocaleString() }}</span>
                    </li>

                    <li v-if="insurance.insurer">
                        <span class="title">Insurer:</span>
                        <span class="sub-title">{{ insurance.insurer }}   </span>
                    </li>
                </ul>
    
              <div v-if="insurance.media.length > 0">
                <b-row>
                  <ul class="ml-3">
                    <li>
                      <span class="title">Documents:</span>
                      <span class="sub-title" v-for="(file, idx2) in insurance.media" :key="'qp-file' + '-' + idx2">
                        <a :href="file.signed_url" target="_blank">
                          {{ file.name }}
                        </a>
                      </span>
                    </li>
                  </ul>
                </b-row>
              </div>
            </div>
            <div v-else>Sorry, Insurance details not verified yet.</div>
          </div>
        </div>
        <div class="col-lg-12">
            <b-button
          :to="{ name: 'contractor-compliance' }"
          type="button"
          variant="outline-primary"
          >Close</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import SvgIcons from "@frontend/pages/includes/SvgIconsComponent.vue";

export default {
  components: {
    moment,
    SvgIcons,
  },
  data() {
    return {
      insurances_info: {},
      insurances_info_loaded: false,
      compliant: false,
    };
  },
  mounted() {
    this.checkComplaint();
    this.getDetails();
  },
  methods: {
    getDetails() {
      this.$root.$data.bsLoader = true;
      axios
        .post("api/contractor/compliance/getInsuranceDetails")
        .then((response) => {
          this.insurances_info = response.data.insurances_info;
          this.insurances_info_loaded = true;
          this.$root.$data.bsLoader = false;
        });
    },

    checkComplaint() {
      axios.post("api/contractor/compliance/checkCompliant").then((response) => {
        if(response.data.check_compliant){
          this.compliant = true;
        }
      });
    },

    momentDate: function (date) {
      return moment(date).format("D MMM YYYY");
    },
  },
  computed: {
    isAllInsuranceVerified() {
      let verified = true;
      this.insurances_info_loaded &&
        this.insurances_info.forEach((data) => {
          if (data.insurance_status != "verified") {
            verified = false;
          }
          //   //return verified = verified && (data.licence_status == 'verified');
        });
      return verified;
    },
  },
};
</script>

<style scoped>
.side-wrapper {
  background-color: #eff0f6;
  min-height: 100vh;
}

.unverified {
  color:#e83e8c;
}

</style>